<template>
  <div class="menu">
    <v-card class="d-flex flex-row mb-6" color="grey lighten-2" flat tile>
      <v-card class="menu-title pt-2 pb-2 pl-2 pr-1" flat tile>{{
        $t("topMenu.create")
      }}</v-card>
      <v-card class="pt-2 pb-2 pl-2 pr-1" flat tile>
        <router-link to="/upload">{{ $t("topMenu.createOneCs") }}</router-link>
      </v-card>
      <v-card class="menu-separation-pipe pt-2 pb-2 pl-1 pr-1" flat tile
        >&#124;</v-card
      >
      <v-card class="pt-2 pb-2 pl-1 pr-10" flat tile>
        <router-link to="/bulk">{{
          $t("topMenu.createSeveralCs")
        }}</router-link>
      </v-card>
      <v-card class="pt-2 pb-2 pl-2 pr-10" flat tile>
        <router-link to="/history">{{ $t("topMenu.history") }}</router-link>
      </v-card>
      <v-card class="pt-2 pb-2 pl-2 pr-0" flat tile>
        <router-link to="/account">{{ $t("topMenu.myAccount") }}</router-link>
      </v-card>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "mainmenu",
};
</script>

<style scoped>
.menu {
  margin-top: 26px;
  margin-left: 30px;
}

span.nobreak {
  white-space: nowrap;
}
a {
  color: #164396 !important;
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-weight: 800;
  text-decoration: none;
  letter-spacing: 0.27px;
  margin-top: -60px;
}

.menu-title {
  color: #164396 !important;
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-weight: 800;
  text-decoration: none;
  letter-spacing: 0.27px;
}

.menu-separation-pipe {
  color: #164396 !important;
  font-family: Roboto, sans-serif;
  font-size: 28px;
  font-weight: 900;
  text-decoration: none;
  letter-spacing: 0.27px;
  margin-top: -8px;
}

a:hover {
  color: #1976d2 !important;
}
</style>